export default __webpack_public_path__ + "static/media/13.050cc84a.jpg";